import axios from "../../http/axios"

export default {
  SET_BEARER(state, accessToken) {
    // Set accessToken
    state.bearer = accessToken;
    localStorage.setItem("accessToken", accessToken)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
  }
}
